import { useNavigate } from "react-router-dom";

function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <main className="PrivacyPolicyPage" style={{ maxWidth: "800px", margin: "0 auto" }}>
      <h1>Privacy Policy</h1>
      <p><em>Last updated: February 2026</em></p>

      <h2>Overview</h2>
      <p>
        Journey Trails is a personal journaling application for mindful plant users.
        We take your privacy seriously. Your journal entries are private and stored securely
        in our database. We do not sell or share your personal data with third parties.
      </p>

      <h2>Data We Collect</h2>
      <p>
        We collect your email address and password (encrypted) for account creation.
        Journal entries, session details, and mood data you enter are stored in our
        database and are only accessible to you.
      </p>

      <h2>Journaling Prompts</h2>
      <p>
        Journey Trails provides intelligent journaling prompts based on your session
        context, including your selected strain, session type (Before/During/After),
        and intention tags. All prompt matching happens entirely within our own system.
        No personal data or journal content is ever sent to any third party to generate prompts.
      </p>
      

      <h2>Cookies & Sessions</h2>
      <p>
        We use session cookies to keep you logged in. These are stored securely
        and expire when you log out or close your browser.
      </p>

      <h2>Contact</h2>
      <p>
        If you have any questions about this privacy policy, please contact us
        through the app.
      </p>

      <button onClick={() => navigate(-1)} style={{ marginTop: "24px" }}>
        Back
      </button>
    </main>
  );
}

export default PrivacyPolicyPage;